const state = () => ({
  content: {
    privacyPolicy: {},
    termsConditions: {},
    header: {
      brand: {},
      socialMediaLinks: [],
      aboutUs: {},
    },
    footer: {
      info: {},
      socialMediaLinks: [],
      links: {
        links: [],
      },
      developer: {},
    },
    home: {
      intro: {
        buttons: [],
      },
      firstSection: {
        benefits: [],
        carouselImages: [],
      },
      secondSection: {
        benefits: [],
        button: {},
        carouselImages: [],
      },
    },
    cookiePolicy: {
      introLayer: {},
      learnMoreLayer: {
        typeOfCookies: [],
      },
    },
  },
});

export default state;
